import React, { useEffect, useState } from "react";

import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
import { Avatar, Button, Card } from 'antd';
const { Meta } = Card;
import { Link } from "react-router-dom";
import Header from "../../../Header/Header";
import SideBar from "../../../SideBar/SideBar";
import Footer from "../../../Footer/Footer";
import DiscountSlider from "./DiscountSlider";


export default function BookDeal() {


  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        <SideBar />

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title mt-2">Book Deal </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">book deal</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="card card-table">
              <div className="card-body">
                <div className="row col-12"  style={{display:'flex', flexDirection:'row',alignItems:'center', justifyContent:'space-between'}}>
            
{/* 
                <Card
    style={{
      width: 300,
    }}
    cover={
      <img
        alt="example"
        src="https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
      />
    }
    actions={[
    <Button  type="primary">Book Now </Button>
    ]}
  >
 <Meta
  title="GRE Examination: Register Today and Save!"
  description="Embark on your academic journey with confidence! Register today for the GRE Examination and take advantage of our exclusive discount offer, saving up to 20% off on your exam fee. Don't miss this opportunity to showcase your skills and pave the way towards your dream career. Make the payment at the discounted price, and within one business day, you'll receive an email with the voucher code to use during registration."
  description1=""
  description2="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
/>
  </Card>

  <Card
    style={{
      width: 300,
    }}
    cover={
      <img
        alt="example"
        src="https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
      />
    }
    actions={[
    <Button  type="primary">Book Now </Button>
    ]}
  >
 <Meta
  title="GRE Examination: Register Today and Save!"
  description="Embark on your academic journey with confidence! Register today for the GRE Examination and take advantage of our exclusive discount offer, saving up to 20% off on your exam fee. Don't miss this opportunity to showcase your skills and pave the way towards your dream career. Make the payment at the discounted price, and within one business day, you'll receive an email with the voucher code to use during registration."
  description1=""
  description2="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
/>
  </Card>
  <Card
    style={{
      width: 300,
    }}
    cover={
      <img
        alt="example"
        src="https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
      />
    }
    actions={[
    <Button  type="primary">Book Now </Button>
    ]}
  >
 <Meta
  title="GRE Examination: Register Today and Save!"
  description="Embark on your academic journey with confidence! Register today for the GRE Examination and take advantage of our exclusive discount offer, saving up to 20% off on your exam fee. Don't miss this opportunity to showcase your skills and pave the way towards your dream career. Make the payment at the discounted price, and within one business day, you'll receive an email with the voucher code to use during registration."
  description1=""
  description2="Make the Payment with the discounted Price and you will receive an email with the voucher code within 1 business days."
/>
  </Card> */}

  <DiscountSlider />
                </div>
              </div>
            </div>
          </div>
          {/* Footer */}
          <Footer />
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  );
}
